exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Landing-___banner__wrapper___2aW1K{background:url(/img/landing/banner-bg.jpg) no-repeat center center;background-size:cover}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Landing-___banner__wrapper___2aW1K"
};